import React from 'react';
import BaseComponent from './BaseContainer';
import { graphql, compose, withApollo } from 'react-apollo';
import { Redirect } from 'react-router';
import EventForm from '../components/form/Event';
import getEvent from '../apollo/graphql/event/get';
import getEvents from '../apollo/graphql/event/getEvents';
import getCategories from '../apollo/graphql/category/getCategories';
import createEvent from '../apollo/graphql/event/create';
import deleteEvent from '../apollo/graphql/event/delete';
import updateEvent from '../apollo/graphql/event/update';
import {
  convertGraphQlToObject,
  convertObjetToGraphQlVariables,
} from '../helpers/contentWithI18n';
import { languages } from '../constants';
import { createTranslationsObject } from '../helpers/translation';

class EventContainer extends BaseComponent {
  constructor(props) {
    super(props);

    const isNew =
      props.match.params.objId === 'new' ||
      props.match.params.objId === undefined;

    this.state = {
      status: {
        loading: true,
        message: null,
        error: null,
        isNew: isNew,
        deletion: { confirm: false },
        block: '',
      },
      redirect: false,
      obj: {
        category_id: null,
        category: { id: null },
        promote_homepage: false,
        event_date: null,
        translations: createTranslationsObject({
          name: '',
          date: '',
          description: '',
          introduction: '',
          content: '<br />',
          section_instagram_title: '',
          cta_text: '',
          cta_url: '',
          tags: '',
          meta_title: '',
          meta_description: '',
          meta_tags: '',
          meta_og_title: '',
          meta_og_description: '',
          meta_og_url: '',
          fb_title: '',
          fb_date: '',
          fb_location: '',
          fb_cta_label: '',
          fb_cta_url: '',
        }),
        blocks: [],
      },
      languages: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  componentDidMount() {
    if (!this.state.status.isNew) {
      this.props.client
        .query({
          query: getEvent,
          variables: { id: this.props.match.params.objId },
        })
        .then(({ data }) => {
          if (getEvent.error) {
            this.setState({
              status: {
                ...this.state.status,
                error: true,
                message: getEvent.error.message,
              },
            });
          }

          const newObject = {
            ...this.state.obj,
            ...convertGraphQlToObject(data.getEvent),
          };
          this.setState({
            ...this.state,
            status: {
              ...this.state.status,
              loading: false,
            },
            obj: {
              ...this.state.obj,
              ...newObject,
              translations: {
                ...this.state.obj.translations,
                ...newObject.translations,
              },
              blocks: [...this.state.obj.blocks, ...newObject.blocks],
            },
          });
        });
    } else {
      this.setState({
        ...this.state,
        status: {
          ...this.state.status,
          loading: false,
        },
      });
    }
  }

  handleChange(event, data, type) {
    let newState = {
      obj: {
        ...this.state.obj,
      },
    };
    let dataIsLanguage = false;
    for (let att of languages) {
      if (att.code === data) {
        dataIsLanguage = true;
      }
    }
    if (dataIsLanguage) {
      //translations data
      newState.obj.translations[data][event.target.id] = event.target.value;
    } else if (type === 'dropdown') {
      //dropdown
      if (data.id === 'block') {
        newState.status.block = data.value;
      } else {
        newState.obj[data.id] = data.value;
      }
    } else if (event.target.files && event.target.files.length > 0) {
      //files
      newState.obj[event.target.id] = event.target.files[0];
    } else if (event.target.id === 'promote_homepage') {
      newState.obj[event.target.id] = !newState.obj[event.target.id];
    } else {
      //simple data
      newState.obj[event.target.id] = event.target.value;
    }
    this.setState(newState);
  }

  handleSubmit(event) {
    event.preventDefault();
    this.setState({
      status: {
        ...this.state.status,
        loading: true,
      },
    });
    const obj = convertObjetToGraphQlVariables(this.state.obj);
    if (this.state.status.isNew) {
      let newObj = {
        ...obj,
      };
      newObj.blocks = [
        this.VideoGallery.getValues(),
        this.ImageGallery.getValues(),
      ];
      if (obj.category) {
        delete newObj.category;
      }
      this.props
        .createEvent({
          variables: {
            ...newObj,
          },
        })
        .then((data) => {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              message: `Création effectuée le ${new Date(
                Date.now(),
              ).toLocaleString()}`,
              isNew: false,
            },
            obj: data.data.createEvent,
            redirect: true,
          });
        })
        .catch((error) => {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              message: error.message,
              error: true,
              isNew: true,
            },
          });
        });
    } else {
      // update object
      let newObj = {
        ...obj,
      };
      newObj.blocks = [
        this.VideoGallery.getValues(),
        this.ImageGallery.getValues(),
      ];
      if (obj.category) {
        //newObj['category_id'] = obj.category.id
        delete newObj.category;
      }
      this.props
        .updateEvent({
          variables: {
            ...newObj,
          },
        })
        .then((data) => {
          this.setState({
            obj: data.data.updateEvent,
            redirect: true,
          });
        })
        .catch((error) => {
          this.setState({
            status: {
              ...this.state.status,
              loading: false,
              message: error.message,
              error: true,
            },
          });
        });
    }
  }

  handleDelete(event, data) {
    event.preventDefault();
    let newState = {
      status: {
        ...this.state.status,
        deletion: {},
      },
    };
    switch (data.confirm) {
      case true:
        newState.status.deletion.confirm = true;
        break;
      case null:
        newState.status.deletion.confirm = false;
        break;
      case false:
        newState.status.deletion.confirm = false;
        this.props
          .deleteEvent({ variables: { id: this.state.obj.id } })
          .then(this.props.history.push('/events'))
          .catch((error) => {
            this.setState({
              status: {
                ...this.state.status,
                loading: false,
                message: error.message,
                error: true,
              },
            });
          });
        break;
      default:
        break;
    }
    this.setState(newState);
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/events" />;
    }
    if (this.state.status.loading) {
      return <div>Chargement</div>;
    }
    return (
      <EventForm
        obj={this.state.obj}
        status={this.state.status}
        categories={this.props.categories}
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
        onDelete={this.handleDelete}
        imageGalleryRef={(ref) => (this.ImageGallery = ref)}
        videoGalleryRef={(ref) => (this.VideoGallery = ref)}
      />
    );
  }
}

const EventContainerEnhanced = compose(
  graphql(getCategories, { name: 'categories' }),
  graphql(updateEvent, { name: 'updateEvent' }),
  graphql(createEvent, { name: 'createEvent' }),
  graphql(deleteEvent, {
    name: 'deleteEvent',
    options: {
      update: (proxy, { data }) => {
        const events = proxy.readQuery({ query: getEvents });
        events.getEvents = events.getEvents.filter(
          (obj) => obj.id !== data.deleteEvent.id,
        );
        proxy.writeQuery({ query: getEvents, data: events });
      },
    },
  }),
)(EventContainer);

export default withApollo(EventContainerEnhanced);



// WEBPACK FOOTER //
// ./src/containers/EventContainer.js